<template>
  <section class="professional-development-section">
    <div class="section__container">
      <p class="section__title text-center">
        Testimonial
      </p>
      <v-row class="section__row">
        <div  class="section__col">
          
          <!-- <p class="section__description text-left">
            We empower our local partners to organize professional development
            events which include effective communication workshops,
            resume-building workshops, and more.
          </p> -->
        </div>
        <v-col cols="12" class="section__col">
          <developer-feedback></developer-feedback>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import DeveloperFeedback from '@/components/DeveloperFeedback.vue';
export default {
  name: 'ProfessionalDevelopmentSection',
  components: {
    'developer-feedback': DeveloperFeedback,
  },
};
</script>

<style scoped>
.professional-development-section {
  padding-block: 2rem 4rem;
  background-color: #DEF3FF;
  
}

@media only screen and (min-width: 960px) {
  .professional-development-section {
    padding-block: 4rem;
    padding-inline: 4rem;
  }
}

.section__title {
  text-align: center;
  font-weight: 700;
  font-size: 2rem !important;
  line-height: 120% !important;
  margin-bottom: 1rem;
}

.section__description {
  font-family: 'Manrope Medium', sans-serif !important;
  font-size: 1.25rem !important;
  line-height: 200% !important;
}

.section__img {
  border-radius: 2rem;
  aspect-ratio: 16/9;
  width: 100%;
}

@media only screen and (min-width: 960px) {
  .section__img {
    width: 80%;
  }
}
</style>
